import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'

// components
import LoginFormController from './Login.form.controller'

// contexts
import { AuthenticationContext } from '../../../contexts/authentication'

import './Login.css'

// mui
import { Paper, Typography } from '@mui/material'

export default function Login() {
    const history = useHistory()
    const authentication = useContext(AuthenticationContext)

    const handleSuccess = (token, refresh) => {
        authentication.setAuthenticationStatus(token, refresh)
        history.push('/inventory')
    }
    
    return (<Paper variant='outlined' sx={{ margin: 'auto', maxWidth: '400px', marginTop: 20, padding: 2}}>
        <Typography variant='h4' sx={{ marginBottom: 4}}>Login</Typography>
        <LoginFormController onSuccess={handleSuccess} />
    </Paper>)
}